import { render } from "./App.vue?vue&type=template&id=83e2639c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=83e2639c&lang=scss"

import exportComponent from "/codebuild/output/src1365795434/src/website-PressPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__